import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AddSurveyDialogData } from '../dialogs-data/add-survey-dialog-data';
import { AddSurveyDialogComponent } from '../dialogs/add-survey-dialog/add-survey-dialog.component';

@Injectable()
export class AddSurveyDialogService {
    constructor(private dialog: MatDialog) {
        }
    matDialogRef: MatDialogRef<AddSurveyDialogComponent>;
    
    

    open(addSurveyDialogData: AddSurveyDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '50%';
        matDialogConfig.maxWidth = '95vw';
        matDialogConfig.data = addSurveyDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(AddSurveyDialogComponent, matDialogConfig);
       
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
